import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, createBlock as _createBlock, createVNode as _createVNode, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = { class: "flex h-full flex-col gap-5 overflow-y-auto p-4 pt-20 xl:p-8 xl:pt-8" };
const _hoisted_2 = { class: "flex flex-col gap-1" };
const _hoisted_3 = { class: "text-2xl font-bold text-eblack-900" };
const _hoisted_4 = {
    key: 0,
    class: "rounded-lg border border-ewhite-200 bg-white p-4 text-sm text-eblack-600"
};
const _hoisted_5 = { class: "flex flex-col gap-1 text-sm font-medium text-eblack-700" };
const _hoisted_6 = { class: "flex flex-col gap-1 text-sm font-medium text-eblack-700" };
const _hoisted_7 = { class: "flex flex-col gap-1 text-sm font-medium text-eblack-700" };
const _hoisted_8 = { class: "flex flex-col gap-1 text-sm font-medium text-eblack-700" };
const _hoisted_9 = ["value"];
const _hoisted_10 = { class: "flex items-end gap-2" };
const _hoisted_11 = ["disabled"];
const _hoisted_12 = {
    key: 0,
    class: "lg:col-span-5 rounded-lg bg-red-50 px-3 py-2 text-sm text-red-600"
};
const _hoisted_13 = {
    key: 2,
    class: "overflow-hidden rounded-lg border border-ewhite-200 bg-white shadow-sm"
};
const _hoisted_14 = { class: "grid grid-cols-[1.1fr_1.2fr_1.5fr_90px_110px] gap-3 border-b border-ewhite-200 bg-ewhite-50 px-4 py-3 text-xs font-semibold uppercase text-eblack-500" };
const _hoisted_15 = { class: "text-right" };
const _hoisted_16 = { class: "min-w-0 truncate" };
const _hoisted_17 = { class: "min-w-0 truncate" };
const _hoisted_18 = { class: "min-w-0 truncate font-mono text-xs" };
const _hoisted_19 = { class: "flex justify-end gap-2" };
const _hoisted_20 = ["title", "onClick"];
const _hoisted_21 = ["title", "onClick"];
const _hoisted_22 = {
    key: 0,
    class: "p-6 text-center text-sm text-eblack-500"
};
const _hoisted_23 = {
    key: 1,
    class: "p-6 text-center text-sm text-eblack-500"
};
import { i18n } from "@/i18n";
import { computed, onMounted, reactive, ref } from "vue";
import { IconDeviceFloppy, IconPencil, IconPlus, IconTrash, IconX, } from "@tabler/icons-vue";
import { useToast } from "vue-toastification";
import { useAuthStore } from "@/domains/auth";
import { useOrganizationStore } from "@/domains/organization";
import { defaultOrganizationBankAccountInput, formatOrganizationBankAccountIban, organizationBankAccountCurrencyOptions, organizationBankAccountSchema, } from "@/domains/organization";
export default /*@__PURE__*/ _defineComponent({
    __name: 'BankAccountsIndex',
    setup(__props) {
        const toast = useToast();
        const authStore = useAuthStore();
        const organizationStore = useOrganizationStore();
        const editingId = ref(null);
        const formError = ref(null);
        const form = reactive({
            ...defaultOrganizationBankAccountInput,
        });
        const orgId = computed(() => authStore.currentOrgId ? Number(authStore.currentOrgId) : null);
        const accounts = computed(() => orgId.value ? organizationStore.bankAccounts[orgId.value] ?? [] : []);
        const isLoading = computed(() => organizationStore.isLoading);
        const isSaving = computed(() => organizationStore.isSaving);
        const bankAccountRequestContext = computed(() => ({
            orgContext: authStore.isSuperAdmin ? "global" : "tenant",
        }));
        async function load() {
            if (!orgId.value)
                return;
            await organizationStore.fetchBankAccounts(orgId.value, bankAccountRequestContext.value);
        }
        async function submit() {
            if (!orgId.value)
                return;
            const parsed = organizationBankAccountSchema.safeParse({ ...form });
            if (!parsed.success) {
                formError.value =
                    parsed.error.issues[0]?.message ??
                        i18n.global.t("settings.auto.revise_los_datos");
                return;
            }
            formError.value = null;
            if (editingId.value) {
                await organizationStore.updateBankAccount(orgId.value, editingId.value, parsed.data, bankAccountRequestContext.value);
                toast.success(i18n.global.t("settings.auto.cuenta_bancaria_actualizada"));
            }
            else {
                await organizationStore.addBankAccount(orgId.value, parsed.data, bankAccountRequestContext.value);
                toast.success(i18n.global.t("settings.auto.cuenta_bancaria_agregada"));
            }
            resetForm();
        }
        function beginEdit(account) {
            editingId.value = account.id;
            formError.value = null;
            Object.assign(form, {
                bank_name: account.bank_name,
                beneficiary_name: account.beneficiary_name,
                iban: account.iban,
                currency: account.currency,
            });
        }
        async function remove(bankAccountId) {
            if (!orgId.value)
                return;
            if (!window.confirm(i18n.global.t("settings.auto.eliminar_esta_cuenta_bancaria")))
                return;
            await organizationStore.removeBankAccount(orgId.value, bankAccountId, bankAccountRequestContext.value);
            if (editingId.value === bankAccountId) {
                resetForm();
            }
            toast.success(i18n.global.t("settings.auto.cuenta_bancaria_eliminada"));
        }
        function resetForm() {
            editingId.value = null;
            formError.value = null;
            Object.assign(form, defaultOrganizationBankAccountInput);
        }
        onMounted(load);
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.$t("settings.auto.cuentas_bancarias")), 1)
                ]),
                (!orgId.value)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.$t("settings.auto.seleccione_una_organizacion_para_administrar_cue")), 1))
                    : (_openBlock(), _createElementBlock("form", {
                        key: 1,
                        "data-test": "bank-account-form",
                        class: "grid gap-3 rounded-lg border border-ewhite-200 bg-white p-4 shadow-sm lg:grid-cols-[1fr_1fr_1.4fr_140px_auto]",
                        onSubmit: _withModifiers(submit, ["prevent"])
                    }, [
                        _createElementVNode("label", _hoisted_5, [
                            _createTextVNode(_toDisplayString(_ctx.$t("settings.auto.banco")), 1),
                            _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((form.bank_name) = $event)),
                                "data-test": "bank-name",
                                type: "text",
                                class: "rounded-lg border border-ewhite-300 px-3 py-2 text-sm font-normal outline-none focus:border-egreen-500"
                            }, null, 512), [
                                [
                                    _vModelText,
                                    form.bank_name,
                                    void 0,
                                    { trim: true }
                                ]
                            ])
                        ]),
                        _createElementVNode("label", _hoisted_6, [
                            _createTextVNode(_toDisplayString(_ctx.$t("settings.auto.beneficiario")), 1),
                            _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((form.beneficiary_name) = $event)),
                                "data-test": "beneficiary-name",
                                type: "text",
                                class: "rounded-lg border border-ewhite-300 px-3 py-2 text-sm font-normal outline-none focus:border-egreen-500"
                            }, null, 512), [
                                [
                                    _vModelText,
                                    form.beneficiary_name,
                                    void 0,
                                    { trim: true }
                                ]
                            ])
                        ]),
                        _createElementVNode("label", _hoisted_7, [
                            _createTextVNode(_toDisplayString(_ctx.$t("settings.auto.cuenta_iban")), 1),
                            _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((form.iban) = $event)),
                                "data-test": "iban",
                                type: "text",
                                class: "rounded-lg border border-ewhite-300 px-3 py-2 text-sm font-normal uppercase outline-none focus:border-egreen-500"
                            }, null, 512), [
                                [
                                    _vModelText,
                                    form.iban,
                                    void 0,
                                    { trim: true }
                                ]
                            ])
                        ]),
                        _createElementVNode("label", _hoisted_8, [
                            _createTextVNode(_toDisplayString(_ctx.$t("settings.auto.moneda")), 1),
                            _withDirectives(_createElementVNode("select", {
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((form.currency) = $event)),
                                "data-test": "currency",
                                class: "rounded-lg border border-ewhite-300 px-3 py-2 text-sm font-normal outline-none focus:border-egreen-500"
                            }, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(organizationBankAccountCurrencyOptions), (currency) => {
                                    return (_openBlock(), _createElementBlock("option", {
                                        key: currency,
                                        value: currency
                                    }, _toDisplayString(currency), 9, _hoisted_9));
                                }), 128))
                            ], 512), [
                                [_vModelSelect, form.currency]
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_10, [
                            _createElementVNode("button", {
                                type: "submit",
                                "data-test": "save-bank-account",
                                class: "inline-flex h-10 items-center justify-center gap-2 rounded-lg bg-egreen-500 px-4 text-sm font-medium text-white disabled:opacity-60",
                                disabled: isSaving.value
                            }, [
                                (editingId.value)
                                    ? (_openBlock(), _createBlock(_unref(IconDeviceFloppy), {
                                        key: 0,
                                        class: "h-4 w-4"
                                    }))
                                    : (_openBlock(), _createBlock(_unref(IconPlus), {
                                        key: 1,
                                        class: "h-4 w-4"
                                    })),
                                _createTextVNode(" " + _toDisplayString(editingId.value ? _ctx.$t("common.actions.save") : _ctx.$t("settings.auto.agregar")), 1)
                            ], 8, _hoisted_11),
                            (editingId.value)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    type: "button",
                                    "data-test": "cancel-edit",
                                    class: "inline-flex h-10 items-center justify-center rounded-lg border border-ewhite-300 px-3 text-sm text-eblack-700",
                                    onClick: resetForm
                                }, [
                                    _createVNode(_unref(IconX), { class: "h-4 w-4" })
                                ]))
                                : _createCommentVNode("", true)
                        ]),
                        (formError.value)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString(formError.value), 1))
                            : _createCommentVNode("", true)
                    ], 32)),
                (orgId.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, [
                            _createElementVNode("span", null, _toDisplayString(_ctx.$t("settings.auto.banco")), 1),
                            _createElementVNode("span", null, _toDisplayString(_ctx.$t("settings.auto.beneficiario")), 1),
                            _createElementVNode("span", null, _toDisplayString(_ctx.$t("settings.auto.cuenta_iban")), 1),
                            _createElementVNode("span", null, _toDisplayString(_ctx.$t("settings.auto.moneda")), 1),
                            _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$t("settings.auto.acciones")), 1)
                        ]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(accounts.value, (account) => {
                            return (_openBlock(), _createElementBlock("div", {
                                key: account.id,
                                "data-test": "bank-account-row",
                                class: "grid grid-cols-[1.1fr_1.2fr_1.5fr_90px_110px] gap-3 border-b border-ewhite-100 px-4 py-3 text-sm text-eblack-700 last:border-b-0"
                            }, [
                                _createElementVNode("span", _hoisted_16, _toDisplayString(account.bank_name), 1),
                                _createElementVNode("span", _hoisted_17, _toDisplayString(account.beneficiary_name), 1),
                                _createElementVNode("span", _hoisted_18, _toDisplayString(_unref(formatOrganizationBankAccountIban)(account.iban)), 1),
                                _createElementVNode("span", null, _toDisplayString(account.currency), 1),
                                _createElementVNode("div", _hoisted_19, [
                                    _createElementVNode("button", {
                                        type: "button",
                                        "data-test": "edit-bank-account",
                                        class: "rounded-lg border border-ewhite-300 p-2 text-eblack-600 hover:bg-ewhite-100",
                                        title: _ctx.$t('settings.auto.editar'),
                                        onClick: ($event) => (beginEdit(account))
                                    }, [
                                        _createVNode(_unref(IconPencil), { class: "h-4 w-4" })
                                    ], 8, _hoisted_20),
                                    _createElementVNode("button", {
                                        type: "button",
                                        "data-test": "delete-bank-account",
                                        class: "rounded-lg border border-red-200 p-2 text-red-600 hover:bg-red-50",
                                        title: _ctx.$t('settings.auto.eliminar'),
                                        onClick: ($event) => (remove(account.id))
                                    }, [
                                        _createVNode(_unref(IconTrash), { class: "h-4 w-4" })
                                    ], 8, _hoisted_21)
                                ])
                            ]));
                        }), 128)),
                        (!isLoading.value && accounts.value.length === 0)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_22, _toDisplayString(_ctx.$t("settings.auto.no_hay_cuentas_bancarias_registradas")), 1))
                            : _createCommentVNode("", true),
                        (isLoading.value)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_23, _toDisplayString(_ctx.$t("settings.auto.cargando_cuentas_bancarias")), 1))
                            : _createCommentVNode("", true)
                    ]))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
